import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../enums/RouteEnum";
import { getFetchQueryErrorStatus } from "../../utils/getFetchQueryErrorStatus";

interface Options {
    shouldFetch: boolean;
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
    error: unknown;
}

/** Redirects to product range when the product detail endpoint returns 404. */
export const useRedirectOnProductDetailNotFound = ({
    shouldFetch,
    isLoading,
    isFetching,
    isError,
    error,
}: Options): boolean => {
    const navigate = useNavigate();

    const isNotFound =
        shouldFetch &&
        !isLoading &&
        !isFetching &&
        isError &&
        getFetchQueryErrorStatus(error) === 404;

    useEffect(() => {
        if (!isNotFound) {
            return;
        }

        navigate(RouteEnum.PRODUCT_RANGE, { replace: true });
    }, [isNotFound, navigate]);

    return isNotFound;
};
